import React from 'react';
import ReactSelect from 'react-select';

const Select = ({
  id,
  name,
  options,
  onChange,
  value,
  label,
  placeholder = 'Seleccionar...',
  error = '',
  isMulti = false,
  isDisabled = false,
  isClearable = true,
  isSearchable = true,
  size = 'md',
  className = '',
  noOptionsMessage = 'No hay opciones',
  required,
}) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: '#1a1b30',
      borderColor: error
        ? 'rgba(220,31,38,0.6)'
        : state.isFocused
          ? 'rgba(0,194,255,0.4)'
          : 'rgba(255,255,255,0.08)',
      boxShadow: state.isFocused
        ? '0 0 0 2px rgba(0,194,255,0.08)'
        : 'none',
      borderRadius: '12px',
      minHeight: size === 'lg' ? '44px' : size === 'sm' ? '36px' : '44px',
      cursor: 'pointer',
      '&:hover': {
        borderColor: error ? 'rgba(220,31,38,0.6)' : 'rgba(255,255,255,0.18)',
      },
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: '#12132a',
      border: '1px solid rgba(255,255,255,0.09)',
      borderRadius: '12px',
      boxShadow: '0 12px 40px rgba(0,0,0,0.7)',
      zIndex: 9999,
      overflow: 'hidden',
    }),
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? '#DC1F26'
        : state.isFocused
          ? '#1a1b30'
          : 'transparent',
      color: state.isSelected ? '#ffffff' : '#E8EAF0',
      cursor: 'pointer',
      fontSize: '14px',
      '&:active': { backgroundColor: '#DC1F26' },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#4A5168',
      fontSize: '14px',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#E8EAF0',
      fontSize: '14px',
    }),
    input: (provided) => ({
      ...provided,
      color: '#E8EAF0',
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: 'rgba(220,31,38,0.15)',
      borderRadius: '6px',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#FCA5A5',
      fontSize: '13px',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: '#F87171',
      borderRadius: '0 6px 6px 0',
      '&:hover': { backgroundColor: 'rgba(239,68,68,0.3)', color: '#fff' },
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#4A5168',
      '&:hover': { color: '#9BA3B8' },
    }),
    clearIndicator: (provided) => ({
      ...provided,
      color: '#4A5168',
      '&:hover': { color: '#F87171' },
    }),
    noOptionsMessage: (provided) => ({
      ...provided,
      color: '#4A5168',
      fontSize: '14px',
    }),
  };

  const handleChange = (selectedOption) => {
    onChange({
      target: {
        name,
        value: isMulti
          ? selectedOption ? selectedOption.map(o => o.value) : []
          : selectedOption ? selectedOption.value : '',
      },
    });
  };

  const selectValue = () => {
    if (isMulti) {
      if (!value || !Array.isArray(value)) return [];
      return options.filter(o => value.includes(o.value));
    }
    if (!value && value !== 0) return null;
    return options.find(o => o.value === value) || null;
  };

  return (
    <div className={`mb-5 ${className} focus:outline-none`}>
      {label && (
        <label
          htmlFor={id}
          className="block text-xs font-semibold mb-1.5 ml-0.5"
          style={{ color: '#9BA3B8', letterSpacing: '0.03em' }}
        >
          {label}{required && <span style={{ color: '#DC1F26', marginLeft: '3px' }}>*</span>}
        </label>
      )}
      <ReactSelect
        id={id}
        name={name}
        options={options}
        value={selectValue()}
        onChange={handleChange}
        placeholder={placeholder}
        isMulti={isMulti}
        isDisabled={isDisabled}
        isClearable={isClearable}
        isSearchable={isSearchable}
        styles={customStyles}
        menuPortalTarget={document.body}
        classNamePrefix="react-select"
        noOptionsMessage={() => noOptionsMessage}
      />
      {error && (
        <p className="mt-1.5 text-xs" style={{ color: '#F87171', paddingLeft: '2px' }}>{error}</p>
      )}
    </div>
  );
};

export default Select;
